import ParamCollection from '../../../../api/types/ParamCollection';
import getHelper from '../../../services/getHelper';
import { BusinessContactFormData } from '../types';

export default class BusinessContactFormHelper extends getHelper<BusinessContactFormData>(
  '/communication/business-contact-form'
) {
  create(formData: BusinessContactFormData, getArgs?: ParamCollection) {
    const request = this.api.createPostRequest(this.uri);

    if (getArgs) {
      request.setQueryParams(getArgs);
    }

    return request.setBodyParams(formData).execute();
  }
}
